import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider'
import LandsCadastralCasesDt from '@/services/dataTransferModules/landsCadastralCasesDt'

const landsCadastralCasesDt = new LandsCadastralCasesDt()

export default function useLandsCadastralCases() {
	const { t: $t } = useI18n()

	const {
		loadEntityFlags: flags,

		entities: fullLandsCadastralCases,
		getEntities: getFullLandsCadastralCases,

		basedEntities: baseLandsCadastralCases,
		getBasedEntities: getBaseLandsCadastralCases,

		extendedEntities: extendLandsCadastralCases,
		getExtendedEntities: getExtendLandsCadastralCases,

		entity: landsCadastralCase,
		getEntity: getLandsCadastralCase,

		entityPreview: landsCadastralCasePreview,
		getEntityPreview: getLandsCadastralCasePreview,

		entityPopup: landsCadastralCasePopup,
		getEntityPopup: getLandsCadastralCasePopup,

		createEntity: createLandsCadastralCase,
		patchEntity: patchLandsCadastralCase,
		updateEntity: putLandsCadastralCase,
		deleteEntity: deleteLandsCadastralCase,
	} = useBlProviders(landsCadastralCasesDt, {
		showErrorNotificationForLoadingAllEntities: true,
		errorNotificationTextForLoadingAllEntities: $t('Error when loading land cadastral records'),

		showErrorNotificationForLoadingOneEntity: true,
		errorNotificationTextForLoadingOneEntity: $t('Error loading land cadastral file'),

		showErrorNotificationForCreatingEntity: true,
		errorNotificationTextForCreatingEntity: $t('Error when creating a land cadastral file'),

		showErrorNotificationForUpdatingEntity: true,
		errorNotificationTextForUpdatingEntity: $t('Error when editing the land cadastral file'),

		showErrorNotificationForDeletingEntity: true,
		errorNotificationTextForDeletingEntity: $t('Error when deleting land cadastral file'),
	})

	const defaults = {
		fieldsCreating: {
			land: null,
			name: '',
			year: null,
			scan_copy_file_id: null,
		},
		fieldsToPatch: [
			'land',
			'name',
			'year',
			'scan_copy_file_id',
			'status',
			'documents',
		],
	}

	return {
		flags,
		fullLandsCadastralCases,
		baseLandsCadastralCases,
		extendLandsCadastralCases,
		landsCadastralCase,
		landsCadastralCasePreview,
		landsCadastralCasePopup,
		defaults,

		getFullLandsCadastralCases,
		getBaseLandsCadastralCases,
		getExtendLandsCadastralCases,
		getLandsCadastralCase,
		getLandsCadastralCasePreview,
		getLandsCadastralCasePopup,
		createLandsCadastralCase,
		putLandsCadastralCase,
		patchLandsCadastralCase,
		deleteLandsCadastralCase,
	}
}
